import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="skeleton"
			className={cn("animate-pulse rounded-md bg-muted", className)}
			{...props}
		/>
	);
}

/** N placeholder rows for lists while a lazy model partial is loading. */
function SkeletonRows({ rows = 5, className }: { rows?: number; className?: string }) {
	return (
		<div className={cn("flex flex-col gap-2", className)}>
			{Array.from({ length: rows }, (_, i) => (
				// biome-ignore lint/suspicious/noArrayIndexKey: static placeholders
				<Skeleton key={i} className="h-9 w-full" style={{ opacity: 1 - i * 0.14 }} />
			))}
		</div>
	);
}

export { Skeleton, SkeletonRows };
